export class CompanyGroup {
    _id: string = '';
    name: string = '';

    loadGroups(r: any) {
        if (r._id)
            this._id = r._id;
        if (r.name)
            this.name = r.name;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/CompanyGroup.model.ts